import { jsx } from "react/jsx-runtime";
import { g as getIcon } from "../../Icon.js";
const Minus = ({ size, isHovered }) => {
  const normal = /* @__PURE__ */ jsx("path", { d: "M14.225 23h19.55v2h-19.55z" });
  const normalHover = /* @__PURE__ */ jsx("path", { d: "M12.225 23h23.55v2h-23.55z" });
  const xSmall = /* @__PURE__ */ jsx("path", { d: "M14.179 22.737h19.642v2.526H14.179z" });
  const xSmallHover = /* @__PURE__ */ jsx("path", { d: "M11.653 22.737h24.694v2.526H11.653z" });
  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover });
};
export {
  Minus as default
};
//# sourceMappingURL=Minus.js.map
